{
  "legal": {
    "meta": {
      "title": "Legal - MAJORITY",
      "description": "See our Terms & Conditions, Privacy Policy, and more."
    },
    "hero": {
      "title": "Terms of use"
  },
    "sections": {
      "majority": "MAJORITY",
      "partners": "Partners",
      "banking_and_card": "Banking and card",
      "miscellaneous": "Miscellaneous"
    }
  }
  
}